/**
 * 랜딩 페이지 라우트 정의
 * FSD pages layer - 라우팅 설정
 */ function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import React, { Suspense, lazy } from 'react';
// 페이지 컴포넌트 lazy loading
var LandingPage = /*#__PURE__*/ lazy(function() {
    return import('./LandingPage');
});
// 랜딩 페이지 로딩 컴포넌트
var LandingPageLoader = function() {
    return /*#__PURE__*/ React.createElement("div", {
        className: "flex items-center justify-center min-h-screen"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary"
    }));
};
// 랜딩 페이지 에러 바운더리
var LandingPageError = function(param) {
    var error = param.error;
    return /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-col items-center justify-center min-h-screen"
    }, /*#__PURE__*/ React.createElement("h1", {
        className: "text-2xl font-bold text-red-600 mb-4"
    }, "페이지 로드 오류"), /*#__PURE__*/ React.createElement("p", {
        className: "text-gray-600"
    }, (error === null || error === void 0 ? void 0 : error.message) || '페이지를 불러올 수 없습니다.'));
};
/**
 * 랜딩 페이지 라우트 설정
 * 
 * @example
 * ```tsx
 * import { landingRoute } from '@edusense/pages-landing';
 * 
 * const routes: RouteObject[] = [
 *   landingRoute,
 *   // ... 다른 라우트들
 * ];
 * ```
 */ export var landingRoute = {
    path: '/',
    element: /*#__PURE__*/ React.createElement(Suspense, {
        fallback: /*#__PURE__*/ React.createElement(LandingPageLoader, null)
    }, /*#__PURE__*/ React.createElement(LandingPage, null)),
    errorElement: /*#__PURE__*/ React.createElement(LandingPageError, null),
    // 메타데이터는 loader에서 설정
    loader: /*#__PURE__*/ _async_to_generator(function() {
        var metaDescription, ogTags;
        return _ts_generator(this, function(_state) {
            // SEO 메타데이터 설정
            if (typeof document !== 'undefined') {
                document.title = 'EduSense - AI 기반 학습 플랫폼';
                // meta description 업데이트
                metaDescription = document.querySelector('meta[name="description"]');
                if (!metaDescription) {
                    metaDescription = document.createElement('meta');
                    metaDescription.setAttribute('name', 'description');
                    document.head.appendChild(metaDescription);
                }
                metaDescription.setAttribute('content', 'AI 기반 개인화 학습 플랫폼. 효율적인 학습과 실시간 피드백으로 학습 목표를 달성하세요.');
                // Open Graph 태그
                ogTags = [
                    {
                        property: 'og:title',
                        content: 'EduSense - AI 기반 학습 플랫폼'
                    },
                    {
                        property: 'og:description',
                        content: 'AI 기반 개인화 학습 플랫폼'
                    },
                    {
                        property: 'og:type',
                        content: 'website'
                    },
                    {
                        property: 'og:url',
                        content: window.location.href
                    }
                ];
                ogTags.forEach(function(param) {
                    var property = param.property, content = param.content;
                    var tag = document.querySelector('meta[property="'.concat(property, '"]'));
                    if (!tag) {
                        tag = document.createElement('meta');
                        tag.setAttribute('property', property);
                        document.head.appendChild(tag);
                    }
                    tag.setAttribute('content', content);
                });
            }
            return [
                2,
                null
            ];
        });
    })
};
// 중첩 라우트를 위한 랜딩 섹션 라우트들
export var landingChildRoutes = [
    {
        path: 'features',
        element: /*#__PURE__*/ React.createElement("div", null, "Features Section")
    },
    {
        path: 'pricing',
        element: /*#__PURE__*/ React.createElement("div", null, "Pricing Section")
    },
    {
        path: 'about',
        element: /*#__PURE__*/ React.createElement("div", null, "About Section")
    }
];
// 전체 랜딩 라우트 구성
export var landingRoutes = _object_spread_props(_object_spread({}, landingRoute), {
    children: landingChildRoutes
});
